'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('pensionSummaryService', function($q, userStore, apiEndpointFactory, dispatcher) {
  return {
    getPensionSummary: () => {
      dispatcher.dispatch('pensionSummary:setLoadingState', true);
      let irn = userStore.getIrn();
      let memberStatus = userStore.getMemberStatus();
      let endpoint = apiEndpointFactory.new({
        endpointUrl: '/' + irn + '/pension-summary',
        authRequired: true,
        apiVersion: 1,
        allowedMethods: ['get']
      });

      if (irn !== undefined) {
        if (memberStatus === 'pensioner') {
          return endpoint.get().then((response) => {
            dispatcher.dispatch('pensionSummary:setPensionSummary', response.data);
            dispatcher.dispatch('pensionSummary:setLoadingState', false);
            return response.data;
          }).catch((response) => {
            dispatcher.dispatch('pensionSummary:setLoadingState', false);
            return $q.reject(response);
          });
        } else {
          dispatcher.dispatch('pensionSummary:setPensionSummary', '');
          dispatcher.dispatch('pensionSummary:setLoadingState', true);
          return '';
        }
      } else {
        dispatcher.dispatch('pensionSummary:setLoadingState', true);
        return $q.reject('IRN is undefined');
      }
    }
  };
});
